import { Instagram } from "lucide-react";

const WhatsIcon = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden {...p}>
    <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
  </svg>
);

const LINKS = [
  { href: "https://instagram.com/edvilsonumbanda", label: "@edvilsonumbanda", sub: "Instagram Edvilson", Icon: Instagram, id: "footer-instagram-edvilson" },
  { href: "https://instagram.com/conexaoestelar_", label: "@conexaoestelar_", sub: "Instagram Conexão Estelar", Icon: Instagram, id: "footer-instagram-conexao" },
  { href: "https://wa.me/555197926121", label: "Suporte", sub: "WhatsApp Edvilson", Icon: WhatsIcon, id: "footer-whatsapp-suporte" },
];

const SocialLink = ({ href, label, sub, Icon, id }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={id}
    className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 text-left transition-[background-color,border-color,transform] duration-500 hover:-translate-y-0.5 hover:border-[#d9b45a]/40 hover:bg-white/[0.06]"
  >
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#d9b45a]/[0.12] text-[var(--gold)]">
      <Icon size={18} />
    </span>
    <span>
      <span className="block text-sm font-medium text-[var(--cream)]">{label}</span>
      <span className="block text-[11px] uppercase tracking-[0.18em] text-[var(--cream)]/60">{sub}</span>
    </span>
  </a>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[var(--night)] py-14 text-center">
    <div data-testid="footer-logos" className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-6 px-5 sm:flex-row sm:gap-10">
      <img src="/assets/footer-logo.webp" alt="Conexão Estelar" className="w-[200px]" />
      <span className="hidden h-10 w-px bg-white/20 sm:block" />
      <img src="/assets/logo_umbanda_para_todos.webp" alt="Umbanda para Todos" className="w-[220px]" />
    </div>
    <div data-testid="footer-social" className="mx-auto mt-10 grid max-w-3xl gap-3 px-5 sm:grid-cols-3">
      {LINKS.map((l) => <SocialLink key={l.id} {...l} />)}
    </div>
    <p className="mt-10 text-sm text-[var(--cream)]/70">Copyright © Conexão Estelar & Comunidade UPT – 2026</p>
    <p className="mt-2 px-5 text-sm text-[var(--cream)]/70">Escola de Desenvolvimento da Consciência e do Despertar Espiritual</p>
    <a
      href="https://cornflowerblue-jay-629377.hostingersite.com/politica-de-privacidade"
      data-testid="footer-privacy-link"
      className="mt-4 inline-block text-sm text-[var(--gold)] underline-offset-4 hover:underline"
    >
      Política de Privacidade
    </a>
  </footer>
);
